import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStep16 = (state) => state.get('step16');

const makeSelectStep16 = () =>
  createSelector(selectStep16, (step16State) => ({
    nameOfDeceased: mapWithDefault(
      step16State,
      () => step16State.getIn(['form', 'nameOfDeceased']),
      ''
    ),

    dateOfInjury: mapWithDefault(
      step16State,
      () => step16State.getIn(['form', 'dateOfInjury']),
      ''
    ),
    theClaimIsBeingMadeUnder: mapWithDefault(
      step16State,
      () => step16State.getIn(['form', 'theClaimIsBeingMadeUnder']),
      ''
    ),
    placeWhereAccidentHappened: mapWithDefault(
      step16State,
      () => step16State.getIn(['form', 'placeWhereAccidentHappened']),
      ''
    ),
    describeWhereTheAccidentOccurred: mapWithDefault(
      step16State,
      () => step16State.getIn(['form', 'describeWhereTheAccidentOccurred']),
      ''
    ),
    describeHowTheAccidentOccurred: mapWithDefault(
      step16State,
      () => step16State.getIn(['form', 'describeHowTheAccidentOccurred']),
      ''
    ),
    checkNameOfDeceased: mapWithDefault(
      step16State,
      () => step16State.getIn(['form', 'checkNameOfDeceased']),
      ''
    ),
  }));

export { makeSelectStep16 };



// WEBPACK FOOTER //
// ./app/containers/FastCover/Step16/selectors.js